import { CoverageItem, FormikCiData } from "@/common/data/formikData";
import dayjs from "dayjs";

export const hasSignificantChanges = (newValues: FormikCiData, oldValues: FormikCiData, mode: "modelRebuilding" | "callIllustrationService"): boolean => {

  // if certain formik values have changed, then the model needs rebuilding
  if (typeof newValues !== "object") {
    return false;
  }

  if (typeof oldValues !== "object" && typeof newValues === "object") {
    return true;
  }

  const newInsured = newValues.insured;
  const oldInsured = oldValues.insured;
  const newEditRider = newValues.editRider;
  const oldEditRider = oldValues.editRider;
  const newWaiver = newValues.editPolicyRider?.payorDisabilityWaiverOfPremiumRiderInfo;
  const oldWaiver = oldValues.editPolicyRider?.payorDisabilityWaiverOfPremiumRiderInfo;
  let changed = false;

  // use parameter 'mode' to alternate detection algorithm
  if (mode === "modelRebuilding" || mode === "callIllustrationService") {
    changed =
      oldValues.premiumPaymentMode != newValues.premiumPaymentMode ||

      oldInsured.dateOfBirth !== newInsured.dateOfBirth ||
      oldInsured.age !== newInsured.age ||
      oldInsured.useBackDate !== newInsured.useBackDate ||
      oldInsured.sex !== newInsured.sex ||
      oldInsured.isSmoker !== newInsured.isSmoker ||
      oldInsured.ratingInfo?.percentageId != newInsured.ratingInfo?.percentageId ||
      oldInsured.basePlanItems.length !== newInsured.basePlanItems.length ||
      oldInsured.basePlanItems.some((oldInsuredBasePlan: CoverageItem, index: number) =>
        oldInsuredBasePlan.planId !== newInsured.basePlanItems[index].planId ||
        oldInsuredBasePlan.faceAmount !== newInsured.basePlanItems[index].faceAmount
      ) ||
      oldInsured.riderItems.length !== newInsured.riderItems.length || 
      oldValues.policyRider != newValues.policyRider ||

      oldWaiver?.dateOfBirth != newWaiver?.dateOfBirth ||
      oldWaiver?.useBackDate != newWaiver?.useBackDate ||
      oldWaiver?.age != newWaiver?.age ||
      oldWaiver?.sex != newWaiver?.sex ||
      oldWaiver?.isSmoker != newWaiver?.isSmoker ||
      oldEditRider != newEditRider;
  } else {
    throw new Error("Not implemented");
  }

  return changed;
};

export const getNearestAge = (
  dateOfBirth: dayjs.Dayjs | string, currentDate?: dayjs.Dayjs
): number | null => {

  const format = "YYYY-MM-DD";
  const currDate = dayjs(dayjs(currentDate ?? dayjs()).format(format));
  const dob = dayjs(dayjs(dateOfBirth).format(format));

  if (!currDate.isValid() || !dob.isValid()) {
    return null;
  }

  let ageInYears = currDate.diff(dob, "year");
  const lastBirthday = dob.add(ageInYears, "year");
  const nextBirthday = dob.add(ageInYears + 1, "year");
  const daysFromLastBirthday = currDate.diff(lastBirthday, "day");
  const daysToNextBirthday = nextBirthday.diff(currDate, "day");

  if (daysFromLastBirthday >= daysToNextBirthday) {
    ageInYears++;
  }

  return ageInYears;
};